module.exports = __webpack_public_path__ + "img/patient-card-tabs-desktop-ru.a6718d9e.jpg";